import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl font-heading">{t('categoryTitle')}</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('categorySubtitle')}</p>
        </div>

        <div className="mt-8 flex justify-center">
          <div className="relative w-full max-w-md">
            <button
              onClick={() => setOpen((v) => !v)}
              className="flex w-full items-center justify-between gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-left text-sm font-medium text-foreground-800 hover:border-secondary-400 cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-grid-line text-secondary-500"></i>
                {t('browseLabel')}
              </span>
              <i className={`ri-arrow-down-s-line text-base transition-transform ${open ? 'rotate-180' : ''}`}></i>
            </button>
            {open && (
              <>
                <div className="fixed inset-0 z-10" onClick={() => setOpen(false)}></div>
                <div className="absolute left-0 right-0 top-full z-20 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 p-1.5 shadow-lg">
                  {categories.map((c) => (
                    <a
                      key={c.name}
                      href={c.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 rounded-md px-2.5 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 cursor-pointer"
                    >
                      <span className="h-9 w-12 flex-shrink-0 overflow-hidden rounded-md bg-background-100">
                        <img src={c.image} alt={c.name} className="h-full w-full object-cover object-top" />
                      </span>
                      <span className="flex-1">{c.name}</span>
                      <i className="ri-arrow-right-up-line text-secondary-500"></i>
                    </a>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.name}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-secondary-400 cursor-pointer"
            >
              <div className="h-28 w-full overflow-hidden">
                <img
                  src={c.image}
                  alt={c.name}
                  title={`${c.name} — USFans`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between gap-2 px-3 py-3">
                <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap overflow-hidden text-ellipsis">
                  {c.name}
                </span>
                <i className="ri-arrow-right-up-line flex-shrink-0 text-secondary-400 transition-colors group-hover:text-secondary-600"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}